<form name="uccp" id="uccp" class="d-none" *ngIf="cart && submitPayment && uccpConfig"
      action="{{uccpConfig.paymentUrl}}" method="POST"
      autocomplete="off">
  <input type="hidden" name="App_Type" value="{{uccpConfig.account}}">
  <input type="hidden" name="ID" value="{{cart.id}}">
  <input type="hidden" name="amt" value="{{amount}}">
  <input type="submit" value="Go to UCCP">
</form>
